import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
        lstMb0: [],
        mb0: {}, 
        filter: {
            search: "",
            mb0contab: ""
        },
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        hasNext: false,
        lastUpdatedRegister: null
	},
    getters: {
        getUpdate:(state) => state.update,
        getMb0:(state) => state.mb0,
        getMb0LanMov:(state) => state.mb0.mb0lanmov,
        getSearch(state) {
            return state.mb0?.search || "";
        },
        getItemsPerPage:(state) => state.itemsPerPage
	},
	mutations: {
        set(state, mb0) {
            state.mb0 = mb0
            if (mb0)
                state.update = true
        },
        initForm(state) {
            const contab = state.mb0?.mb0contab || null
            state.insert = true
            state.update = false
            state.mb0 = contab ? { mb0contab: contab } : {}
        },
        setParamsDataTable(state, payload) {
            state.lstMb0 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setMb0(state, mb0) {
            state.mb0 = mb0
        },
        setLstMb0(state, lstMb0) {
            state.lstMb0 = lstMb0
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
       setSearch(state, search) {
            if (!state.mb0) state.mb0 = {};
            state.mb0.search = search;
       },
       setMb0Contab(state, contab) {
            if (!state.mb0) state.mb0 = {};
            state.mb0.mb0contab = contab;
       }
	},
	actions: {
         initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, mb0lanmov) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Financial/BankMovementPattern/Find/${mb0lanmov}`)
                .then(response => {
                    let mb0 = Utils.ValidateAxiosResponse(response.data);
                    commit("set", mb0)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Financial/BankMovementPattern/Insert", getters.getMb0)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setMb0", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Financial/BankMovementPattern/Update", getters.getMb0)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Financial/BankMovementPattern/Delete/${getters.getMb0LanMov}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/padroes-lancamentos-bancarios")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, getters, dispatch }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Financial/BankMovementPattern/FindList`)
                .then(response => {
                    let lstMb0 = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstMb0", lstMb0)
                    commit("setHasNext", lstMb0.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstMb0", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, dispatch }, { 
            search = "",
            bankAccount = "",
            limit = 20, 
            page = 1, 
        }) {
            commit("setLoading", true)
            
            let payload = await this._vm.$axios.get(
                `/Financial/BankMovementPattern/Search?` +
                `search=${search}` +
                `&bankAccount=${bankAccount}` +
                `&limit=${limit}` +
                `&page=${page}`
            )
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstMb0", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            commit("initForm")
            return payload
        },
       async saveMb0({ commit, dispatch }, mb0Data) {
        dispatch("parameters/openGlobalLoading", {
            showLoadingGlobal: true,
            text: "Salvando",
            indeterminate: true
        }, { root: true })

            try {
               const body = {
                    mb0lanmov: mb0Data.mb0lanmov,
                    mb0contar: mb0Data.mb0contar,
                    mb0histor: mb0Data.mb0histor,
                    dr3observa: mb0Data.dr3observa
                }

                const url = `/Financial/BankPostingBach/ManualSave`
                            + `?mb0lanmov=${encodeURIComponent(mb0Data.mb0lanmov)}`
                            + `&accountingDate=${encodeURIComponent(mb0Data.accountingDate)}`
                            + `&selectedType=${encodeURIComponent(mb0Data.selectedType)}`
                            + `&totalValue=${mb0Data.totalValue}`
                            + `&observation=${mb0Data.observation || ""}`
                            + `&fn3agente=${encodeURIComponent(mb0Data.fn3agente || "")}`
                            + `&fn3conta=${encodeURIComponent(mb0Data.fn3conta || "")}`

                let response = await this._vm.$axios.post(url, body)

                const validated = Utils.ValidateAxiosResponse(response.data)
                commit('setLastUpdatedRegister', validated)
                commit("setMb0", {})
                return validated  
            } catch (error) {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false

            } finally {
                dispatch("parameters/openGlobalLoading", {
                    showLoadingGlobal: false,
                    text: ""
                }, { root: true })
            }
        },
	},
}
